// extracted by mini-css-extract-plugin
module.exports = {"reviewStar":"ReviewsHeader_reviewStar__Uc8Zm","reviewStarMobile":"ReviewsHeader_reviewStarMobile___YDB2","textColor":"ReviewsHeader_textColor__67Hg6"};